import { useEffect, useState } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import useClubBaseInfoData from '../../state/clubBaseInfo/UseClubBaseInfoData';

import useBaseUsasClubData from '@usas/ui-web/state/clubBase/UseBaseUsasClubData';
import useSelectOrgUnitData from '@usas/ui-web/state/selectOrgUnit/UseSelectOrgUnitData';
import usePersonOrgRoleData from '@usas/ui-web/state/personOrgRole/UsePersonOrgRoleData';
import useClubPersistentStorage from '@usas/ui-web/state/clubPersistentStorage/UseClubPersistentStorage';

import { navigateToCrossUiRoute } from '@usas/ui-web/utils/FormatCrossUiRoute';
import Constants from '@usas/ui-web/utils/Constants';

const INITIAL_STATE = {
  returnUrl: '',
  uIProjectName: '',
  backToSystemLabel: ''
};

const useClubHeader = () => {
  const navigate = useNavigate();
  const { getPersistentStorage } = useClubPersistentStorage();
  const { baseUsasClubState, clearBaseUsasClubObjData } = useBaseUsasClubData();
  const { clubBaseInfoState, getClubBaseInfo } = useClubBaseInfoData();
  const { selectOrgUnitState, resetSelectOrgUnitState } = useSelectOrgUnitData();
  const { clearArrayData } = usePersonOrgRoleData();
  const [state, setState] = useState(INITIAL_STATE);

  const isSsrpCurrent = () => {
    const ssrpExpDate = new Date(clubBaseInfoState.objData.ssrpExpirationDate);
    const expDd = ssrpExpDate.getDate();
    const expMm = ssrpExpDate.getMonth() + 1;
    const expYy = ssrpExpDate.getFullYear();
    const expDt = new Date(expMm + '-' + expDd + '-' + expYy);

    const today = new Date();
    const dd = today.getDate();
    const mm = today.getMonth() + 1;
    const yy = today.getFullYear();
    const todayDt = new Date(mm + '-' + dd + '-' + yy);

    return expDt >= todayDt;
  }

  const getLogoOverlayText = () => {
    const ssrpExpDate = new Date(clubBaseInfoState.objData.ssrpExpirationDate);
    const expMm = ssrpExpDate.toLocaleString('default', { month: 'long' });
      
    const expYy = ssrpExpDate.getFullYear();
    let textToOverlay = `Until ${expMm} ${expYy}`;

    return textToOverlay;
  }

  const getXCoord = () => {
    const ssrpExpDate = new Date(clubBaseInfoState.objData.ssrpExpirationDate);
    const expMm = ssrpExpDate.toLocaleString('default', { month: 'long' });

    return 58 - (expMm.length * 2.5);
  }

  const getClubHeadCoachName = () => {
    const clubBaseInfoObj = clubBaseInfoState.objData;
    const headCoachName = `${clubBaseInfoObj.headCoachPreferredName || clubBaseInfoObj.headCoachFirstName || ''} ${clubBaseInfoObj.headCoachLastName || ''}`;

    return headCoachName.trim();
  };

  const getClubNotInGoodStandingReasons = () => {
    let notInGoodStandingReasons = '';

    if (Array.isArray(clubBaseInfoState.objData.usasClubGoodStanding)) {
      for (const notInGoodStandingReason of clubBaseInfoState.objData.usasClubGoodStanding) {
        if (notInGoodStandingReason.notInGoodStandingReason) {
          if (notInGoodStandingReasons) {
            notInGoodStandingReasons += `, ${notInGoodStandingReason.notInGoodStandingReason}`;
          } else {
            notInGoodStandingReasons = notInGoodStandingReason.notInGoodStandingReason;
          }
        }
      }
    }

    return notInGoodStandingReasons;
  };

  const onBackClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (state.uIProjectName !== import.meta.env.VITE_PROJECT_NAME) {
      navigateToCrossUiRoute(state.uIProjectName, state.returnUrl, navigate);
    } else {
      resetSelectOrgUnitState();
      clearArrayData();
      clearBaseUsasClubObjData();

      navigate(state.returnUrl);
    }
  };

  useEffect(() => {
    const { returnUrl, uIProjectName, backToSystemLabel } = getPersistentStorage();

    setState({
      returnUrl: returnUrl || '/',
      uIProjectName: uIProjectName || Constants.UI_PROJECT_NAMES.CLUB,
      backToSystemLabel: backToSystemLabel || 'Back to Club Search'
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (baseUsasClubState.isObjLoaded === true) {
      getClubBaseInfo(baseUsasClubState.objData.usasClubId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [baseUsasClubState]);

  return {
    xCoord: getXCoord(),
    isSSRPCurrent: isSsrpCurrent(),
    clubHeadCoach: getClubHeadCoachName(),
    logoOverlayText: getLogoOverlayText(),
    backToSelectionText: 'Back to Selection',
    clubNotInGoodStandingReasons: getClubNotInGoodStandingReasons(),
    state,
    clubBaseInfoState,
    selectOrgUnitState,
    onBackClicked
  };
};

export default useClubHeader;